import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    const message = this.getMessage();
    const messageHash = this.getMessageHash(message);
    const dismissedBanners = this.getDismissedBanners();

    if (dismissedBanners.includes(messageHash)) {
      this.removeBanner();
    }
  }

  dismiss() {
    const message = this.getMessage();
    const messageHash = this.getMessageHash(message);
    const dismissedBanners = this.getDismissedBanners();

    if (!dismissedBanners.includes(messageHash)) {
      dismissedBanners.push(messageHash);
      localStorage.setItem(
        "dismissedBanners",
        JSON.stringify(dismissedBanners),
      );
    }

    this.removeBanner();
  }

  removeBanner() {
    // Remove the banner wrapper if it exists, otherwise remove the element itself
    const bannerWrapper = document.getElementById("banner");
    if (bannerWrapper) {
      bannerWrapper.remove();
    } else {
      this.element.remove();
    }
  }

  getMessage() {
    // Get the message text from the first span (the message; the dismiss
    // button's label span comes after it)
    const messageElement = this.element.querySelector("span");
    return messageElement ? messageElement.textContent.trim() : "";
  }

  getDismissedBanners() {
    const stored = localStorage.getItem("dismissedBanners");
    return stored ? JSON.parse(stored) : [];
  }

  getMessageHash(message) {
    // Simple hash function to create a unique identifier for each message
    let hash = 0;
    for (let i = 0; i < message.length; i++) {
      const char = message.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash; // Convert to 32bit integer
    }
    return hash.toString();
  }
}
